/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    yeaBui13: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Year Built',
        defaultMessage: 'Year Built'
    },
    con15: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Construction',
        defaultMessage: 'Construction'
    },
    ifOthExp16: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.If Other, Explain',
        defaultMessage: 'If Other, Explain'
    },
    numOfSto17: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Number of Stories',
        defaultMessage: 'Number of Stories'
    },
    firProDisToFirHyd20: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Fire Protection: Distance to Fire Hydrant',
        defaultMessage: 'Fire Protection: Distance to Fire Hydrant'
    },
    burAla23: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Burglary Alarm',
        defaultMessage: 'Burglary Alarm'
    },
    mon24: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Monitored',
        defaultMessage: 'Monitored'
    },
    spr25: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Sprinklered',
        defaultMessage: 'Sprinklered'
    },
    hea29: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Heating',
        defaultMessage: 'Heating'
    },
    ifOthExp30: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.If Other, Explain',
        defaultMessage: 'If Other, Explain'
    },
    heaYeaLasUpd31: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Heating - Year last updated',
        defaultMessage: 'Heating - Year last updated'
    },
    eleSys32: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Electrical System',
        defaultMessage: 'Electrical System'
    },
    ifOthExp33: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.If Other, Explain',
        defaultMessage: 'If Other, Explain'
    },
    eleYeaLasUpd34: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Electrical - Year last updated',
        defaultMessage: 'Electrical - Year last updated'
    },
    pluYea35: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Plumbing Year',
        defaultMessage: 'Plumbing Year'
    },
    rooYea36: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Roofing Year',
        defaultMessage: 'Roofing Year'
    },
    insDate: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Inspection Date',
        defaultMessage: 'Inspection Date'
    },
    elcDate: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Electrical - Date last updated',
        defaultMessage: 'Electrical - Date last updated'
    },
    heaDateLasUpd31: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Heating - Date last updated',
        defaultMessage: 'Heating - Date last updated'
    },
    heatingOthDnO: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Heating, If Other, Explain',
        defaultMessage: 'Heating, If Other, Explain'
    },
    utilitiesDetails: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Utilities Details',
        defaultMessage: 'Utilities Details'
    },
    crime: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Crime',
        defaultMessage: 'Crime'
    },
    desProDev: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Description of Protected Devices',
        defaultMessage: 'Description of Protected Devices'
    },
    proGra: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Protection Grade',
        defaultMessage: 'Protection Grade'
    },
    firProDisToFirDep: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Fire Protection: Distance to Fire Department',
        defaultMessage: 'Fire Protection: Distance to Fire Department'
    },
    firProDisToFirDepDnO: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Distance to responding fire department',
        defaultMessage: 'Distance to responding fire department'
    },
    firProDisToFirHall:
    {
        id: 'quoteandbind.PPLProLinedirectives.templates.Fire Protection: Distance to Fire Hall',
        defaultMessage: 'Fire Protection: Distance to Fire Hall'
    },
    firProDisToFirHyd: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Fire Protection: Distance to Fire Hydrant',
        defaultMessage: 'Fire Protection: Distance to Fire Hydrant'
    },
    firProDisToFirHydDnO: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Distance to hydrant',
        defaultMessage: 'Distance to hydrant'
    },
    fireProtection: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Fire Protection',
        defaultMessage: 'Fire Protection'
    },
    rooDatLasUpd: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Roof - Date last updated',
        defaultMessage: 'Roof - Date last updated'
    },
    noOfStories: {
        id: 'quoteandbind.PPLProLinedirectives.templates.No. of Stories',
        defaultMessage: 'No. of Stories'
    },
    numOfStories: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Number of Stories',
        defaultMessage: 'Number of Stories'
    },
    conTypBuiOthDnO: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Construction - other - explain',
        defaultMessage: 'Construction - other - explain'
    },
    occ: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Occupancy',
        defaultMessage:'Occupancy'
    },
    propertyDetails: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Property Details',
        defaultMessage:'Property Details'
    },
    typOfNeiOccOthDnO: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Neighbouring Occupancies - If Other, Explain',
        defaultMessage:'Neighbouring Occupancies - If Other, Explain'
    },
    addressOfLocRisk:{
        id: 'quoteandbind.PPLProLinedirectives.templates.Address of: Location',
        defaultMessage: 'Address of: Location'
    },
    removeInfo: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Remove Property',
        defaultMessage: 'Remove Property',
    },
    removeInfoDesc: {
        id: 'quoteandbind.PPLProLinedirectives.templates.riskanalysisRemovalMsg',
        defaultMessage: 'Are you sure you want to remove this Property from the list?',
    },
    desc: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Description',
        defaultMessage: 'Description'
    }, 
    prty: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Property',
        defaultMessage: 'Property'
    }, 
});